/**
 * Curator pubkey — MK Fain's hex pubkey.
 * Used as the default follow list for logged-out users and users without their own follow list,
 * ensuring new visitors see a hand-curated feed of quality content.
 */
export const CURATOR_PUBKEY = '932614571afcbad4d17a191ee281e39eebbb41b93fac8fd87829622aeb112f4d';
